import React from 'react';
import { FiClock } from 'react-icons/fi';
import styles from '../../assets/scss/Notifications/DashboardNotification.module.scss';
import dummyProfile from '../../assets/images/Profile.png';
import { BaseURL } from '../../lib/api';

const DashboardNotification = ({ notification }) => {
    const { message, createdBy, createdAt, storeName } = notification;

    const resolveImageUrl = (path) => {
        if (!path) return dummyProfile;
        return path.startsWith("http") ? path : `${BaseURL}/${path}`;
    };

    const userName = storeName || (createdBy ? `${createdBy.firstName || ''} ${createdBy.lastName || ''}`.trim() : 'System');
    const profileImg = resolveImageUrl(createdBy?.profile);
    
    // Format date in DD/MM/YYYY format as seen in the screenshot
    const formatTime = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    };

    return (
        <div className={styles.toastContainer}>
            <div className={styles.imageWrapper}>
                <img src={profileImg} alt={userName} onError={(e) => e.target.src = dummyProfile} />
            </div>
            <div className={styles.contentWrapper}>
                <p className={styles.message}>
                    <strong>{userName}</strong> {message}
                </p>
                <div className={styles.metaWrapper}>
                   {createdBy?.role && <span className={styles.badge}>{createdBy.role}</span>}
                   {createdBy?.type && <span className={styles.badge}>{createdBy.type}</span>}
                </div>
                <div className={styles.timeWrapper}>
                    <FiClock className={styles.clockIcon} />
                    <span>{formatTime(createdAt)}</span>
                </div>
            </div>
        </div>
    );
};

export default DashboardNotification;
